/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetAddressSuggestion Input Action
 */
export class GetAddressSuggestionInput implements Msdyn365.IActionInput {
    public searchType: string;
    public search: string;
    public limit: number;

    constructor(searchType: string, search: string, limit: number) {
        this.searchType = searchType;
        this.search = search;
        this.limit = limit;
    }

    public getCacheKey = () => `GetAddressSuggestion`;
    public getCacheObjectType = () => 'GetAddressSuggestion';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetAddressSuggestionData {
    '@odata.context'?: string;
    summary: {};
    results: [];
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetAddressSuggestionInput('', '', 8);
};

async function action(input: GetAddressSuggestionInput, ctx: Msdyn365.IActionContext): Promise<IGetAddressSuggestionData> {
    const azureMapsPoiEndpoint = 'https://atlas.microsoft.com/search/fuzzy/json';
    const azureMapsAddressEndpoint = 'https://atlas.microsoft.com/search/address/json';

    // API key for azure maps service
    const AzureMaps_SubscriptionKey = '44Ik7pMIeh98G9UCcOP4BophcGfoMXivc2K1mR7AU2W6SzL6K6PYJQQJ99AHAC5RqLJI3XEVAAAgAZMPVQMV';

    const { postBody } = ctx.requestContext;
    const content = postBody?.content?.toString();
    let searchType: string | undefined;
    let search: string;
    let limit: number;

    try {
        if (content) {
            const parsedContent: GetAddressSuggestionInput = JSON.parse(content);
            searchType = parsedContent.searchType;
            search = parsedContent.search;
            limit = parsedContent.limit;

            const params = new URLSearchParams({
                'subscription-key': AzureMaps_SubscriptionKey,
                query: search,
                'business-suggestions': 'true',
                typeahead: 'false',
                limit: limit.toString()
            });

            let urlWithParams: string = '';
            urlWithParams =
                searchType === 'CompanyName'
                    ? `${azureMapsPoiEndpoint}?${params.toString()}`
                    : `${azureMapsAddressEndpoint}?${params.toString()}`;

            const response = await Msdyn365.sendRequest<IGetAddressSuggestionData>(urlWithParams, 'get', {});

            if (response.status === 200 && response.data) {
                return { ...response.data };
            }
            return { ...response.data };
        }
    } catch (error) {
        return { summary: {}, results: [] };
    }

    return { summary: {}, results: [] };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAddressSuggestionData>>action,
    id: 'GetAddressSuggestion',
    input: createInput
});
